<template>
  <main class="analytics">
    <p>{{ msg }}</p>
  </main>
</template>

<script>
  export default {
    name: 'analytics',
    data () {
      return {
        msg: 'Analytics'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/pages/Analytics.vue